import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { omit } from 'lodash-es';

import VirtualizedCheckbox from './VirtualizedCheckbox';

const CoverPhotoModal = ({
  coverPhotoList,
  coverPhotoModal,
  postCoverPhoto,
  toggleFunction,
  selectCoverPhoto
}) => {
  const coverPhotoListCopy = omit(coverPhotoList, ['catalogID']);

  // (bnikom) create array of lotNums + array of lotUrls
  const coverPhotoListLotNums = Object.keys(coverPhotoListCopy);
  const coverPhotoListLotURLs = Object.values(coverPhotoListCopy);

  return (
    <Modal isOpen={coverPhotoModal.show} className="step-6-modal cover-photo-modal" centered>
      <ModalHeader toggle={toggleFunction} className="pb-0 ml-4" tag="h1">
        Change Session Cover Photo
      </ModalHeader>
      <ModalBody className="py-0 mx-4">
        <p className="ml-3">To change your session photo, select an image from below.</p>
        <div className="cover-photo-body">
          <VirtualizedCheckbox
            columnCount={4}
            columnWidth={185}
            items={coverPhotoListLotURLs.map((url, index) => ({
              lotNum: coverPhotoListLotNums[index],
              src: url,
              checked: coverPhotoModal.lot === url
            }))}
            labelKey="lotNum"
            selectCoverPhoto={item => selectCoverPhoto(item.checked ? item.src : null)}
            rowHeight={250}
            width={760}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="mr-3"
          color="primary"
          onClick={() => {
            toggleFunction();
            coverPhotoModal.lot !== null && postCoverPhoto();
          }}
        >
          Save Changes
        </Button>
        <Button color="link" onClick={() => toggleFunction()}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CoverPhotoModal;
